import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpSentEvent,
  HttpHeaderResponse,
  HttpProgressEvent,
  HttpUserEvent
} from '@angular/common/http';
import { tap, catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';


@Injectable()
export class MainInterceptor implements HttpInterceptor {

  constructor(
    private loaderService: LoaderService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    this.requestStarted();
    return next.handle(req).pipe(
      map(data => data),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.requestEnded();
        }
      }),
      catchError((error, caught) => {
        this.requestEnded();
        return throwError(error);
      }) as any
    );
  }

  private requestEnded() {
    this.loaderService.stop();
  }

  private requestStarted() {
    this.loaderService.start();
  }


}
